import { KhoDeNghiXuatKho } from './../kho-de-nghi-xuat-kho-model/kho-de-nghi-xuat-kho.model';
import { QueryResultsModel } from './../../../../../../core/_base/crud/models/query-models/query-results.model';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, ViewChildren } from '@angular/core';
import { DatePipe } from '@angular/common';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { tap, filter } from 'rxjs/operators';
import {merge, BehaviorSubject } from 'rxjs';
//Datasource
import { KhoDeNghiXuatKhoDataSource } from '../kho-de-nghi-xuat-kho-datasource/kho-de-nghi-xuat-kho.datasource';
//Service
import { KhoDeNghiXuatKhoService } from '../kho-de-nghi-xuat-kho-service/kho-de-nghi-xuat-kho.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel, MessageType } from '../../../../../../core/_base/crud';
import { KhoDeNghiXuatKhoEditComponent } from '../kho-de-nghi-xuat-kho-edit/kho-de-nghi-xuat-kho-edit.component';
//Model
import { KhoDeNghiXuatKhoDuyetComponent } from '../kho-de-nghi-xuat-kho-duyet/kho-de-nghi-xuat-kho-duyet.component';
import { KhoDeNghiXuatKhoDetailComponent } from '../kho-de-nghi-xuat-kho-detail/kho-de-nghi-xuat-kho-detail.component';
import { TokenStorage } from '../../../../../../core/auth/_services';
import { Router } from '@angular/router';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { HC_DangKyTiepKhachService } from '../../../hanh-chanh/hc-dang-ky-tiep-khach/hc-dang-ky-tiep-khach-service/hc-dang-ky-tiep-khach.service';
import { debug } from 'console';


@Component({
	selector: 'm-kho-de-nghi-xuat-kho-list',
	templateUrl: './kho-de-nghi-xuat-kho-list.component.html',
	styleUrls: ['../kho-de-nghi-xuat-kho.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class KhoDeNghiXuatKhoListComponent implements OnInit {
	//#region Variable

	// Config Form 
	CONFIG: CommonConFig;
	
	// Table fields
	dataSource: KhoDeNghiXuatKhoDataSource;
	displayedColumns = [];
	availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'SOPHIEU',
            displayName: 'Số phiếu',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'LOAIPHIEU',
            displayName: 'Loại phiếu',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'NGUOILAPPHIEU',
            displayName: 'Người lập phiếu',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'NGAYLAPPHIEU',
            displayName: 'Ngày lập phiếu',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 2,
            name: 'TRANGTHAI',
            displayName: 'Trạng thái',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 99,
            name: 'ACTIONS',
            displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
        }
	];

	@ViewChildren('focus') focus ;
	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
	@ViewChild('sort1', {static: true}) sort: MatSort;
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;
	@ViewChild('searchFullText', {static: true}) searchFullText: ElementRef;
	// Selection
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<KhoDeNghiXuatKho>(true, []);

	KhoDeNghiXuatKhoResult: KhoDeNghiXuatKho[] = [];
	tmpKhoDeNghiXuatKhoResult: KhoDeNghiXuatKho[] = [];
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();

	// Biến dữ liệu 
	saveNewTTHV: number[] = []
	flagHighlight: boolean = false;
	previousIndex: number;
	fixedPoint = 2;
	category_path = "KHOPDNXK";
	openDialog: boolean = false;
	IdUser = 0;

	// ROLES
	TAO = '139';
	// SUA = '140';
	// XOA = '141';
	// CHI_TIET = '142';
	// KIEM_TRA = '143';
	HUY = '1301';

	LIST_ROLES_USER : [] = [];

	SHOW_BUTTON_CREATE = new BehaviorSubject<boolean>(false);
	// SHOW_BUTTON_EDIT = new BehaviorSubject<boolean>(false);
	// SHOW_BUTTON_DELETE = new BehaviorSubject<boolean>(false);
	// SHOW_BUTTON_DETAIL = new BehaviorSubject<boolean>(false);
	// SHOW_BUTTON_CHECK = new BehaviorSubject<boolean>(false);
	SHOW_BUTTON_REMOVE = new BehaviorSubject<boolean>(false);

	// filter on grid
	haveFilter: boolean = false;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};
	disableButtonFilter: any = {};
	isClearAll: boolean = false;
	public datatree: BehaviorSubject<any[]> = new BehaviorSubject([]);
	CoQuyen:string='0';
	// Tình trạng list
	optionsTrangThai = [
		{
			id: 1,
			name: 'Đang soạn thảo',
			value: 'KHOPDNXK_LUUNHAP',
			position: 1,
			show: true
		},
		{
			id: 2,
			name: 'Chờ xử lý',
			value: 'KHOPDNXK_CHODUYET',
			position: 2,
			show: true
		},
		{
			id: 4,
			name: 'Hoàn tất',
			value: 'KHOPDNXK_HOANTAT',
			position: 5,
			show: true
		},
		{
			id: 5,
			name: 'Đã hủy',
			value: 'KHOPDNXK_DAHUY',
			position: 6,
			show: true
		},
		{
			id: 7,
			name: 'Đã xóa',
			value: 'KHOPDNXK_DAXOA',
			position: 7,
			show: false
		}
	];

	optionLoaiPhieu = [];

	//#endregion Variable

	//#region Phím tắt
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.altKey && event.keyCode == 78 && !this.openDialog && this.SHOW_BUTTON_CREATE) {
			this.openDialog = true;
			this.addKhoDeNghiXuatKho();
		}
	}
	//#endregion Phím tắt

	//#region Constructor
	constructor(
		private KhoDeNghiXuatKhoService: KhoDeNghiXuatKhoService,
		private DungChungService: DungChungService,
		public  dialog: MatDialog,
		private router: Router,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private tokenStorage: TokenStorage,
		private hc_dangkytiepkhachsService: HC_DangKyTiepKhachService,
		private layoutUtilsService: LayoutUtilsService) {
			let user = JSON.parse(localStorage.getItem("UserInfo"));
			this.LIST_ROLES_USER = user.roles;
		}
	//#endregion Constructor

	//#region LOAD DATA
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		// Lấy IdUser đăng nhập
		this.tokenStorage.getIDUser().subscribe(t => {
			this.IdUser = +t;
		});

		// Set value filter
		this.haveFilter = true;
		this.disableButtonFilter['Tinhtrang'] = true;
		this.disableButtonFilter['SoPhieu'] = true;
		this.disableButtonFilter['TenNguoiTao'] = true;
		this.tmpfilterText = Object.assign({}, this.filterText);

		// Set SoPhieu
		this.filterGroupDataChecked['SoPhieu'] = '';
		this.filterGroupDataChecked['TenNguoiTao'] = '';
		this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);

		this.callServiceFilterInList();
		this.showColumnsInTable();
		this.applySelectedColumns();

		// Set chức năng button
		this.SHOW_BUTTON_CREATE.next(this.isTrueButton(this.TAO));
		this.SHOW_BUTTON_REMOVE.next(this.isTrueButton(this.HUY));

		// If the KhoDeNghiXuatKhoTmp changes the sort , reset back to the first page.
		this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
		merge(this.sort.sortChange, this.paginator.page)
			.pipe(
				tap(() => {
					this.loadKhoDeNghiXuatKhoList();
					this.forcusEvents();
				})
			)
			.subscribe();
		//Set title to page breadCrumbs
		let breadcrumbs = [{ title: 'Kho' }, { title: 'Đề nghị xuất kho', page: '/de-nghi-xuat-kho' }];
		this.subheaderService.setBreadcrumbs(breadcrumbs);

		// Init DataSource
		this.dataSource = new KhoDeNghiXuatKhoDataSource(this.KhoDeNghiXuatKhoService);
		let queryParams = new QueryParamsModel({});

		this.dataSource.entitySubject.subscribe(res => {
			this.KhoDeNghiXuatKhoResult = res
			this.tmpKhoDeNghiXuatKhoResult = []
			if(this.KhoDeNghiXuatKhoResult != null){
				for(let i = 0; i < this.KhoDeNghiXuatKhoResult.length; i++){
					let tmpElement = new KhoDeNghiXuatKho();
					tmpElement.copy(this.KhoDeNghiXuatKhoResult[i])
					this.tmpKhoDeNghiXuatKhoResult.push(tmpElement);
				}
			}
		});
		this.loadKhoDeNghiXuatKhoList();
		this.layoutUtilsService.setUpPaginationLabels(this.paginator);
	}
	//#endregion LOAD DATA
	//#region AferView
	ngAfterViewInit() {
		this.changeDetect.detectChanges();
	}
	//#endregion AfterView

	async callServiceFilterInList(){
		var index = 0;
		let res = await this.DungChungService.layDanhSachLoaiPhieu(1).toPromise();
		if(res && res.status == 1){
			this.optionLoaiPhieu = res.data;
			this.filterGroupDataChecked['LoaiPhieu'] = this.optionLoaiPhieu.map(a =>{
				index = index + 1;
				return {
					id: index,
					name: a.Ten,
					value: a.Id,
					checked: false,
				}
			})
			this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);
		}else{
			this.layoutUtilsService.showErorr("Không tải được danh sách loại phiếu");
		}

		var i = 0;
		this.filterGroupDataChecked['TrangThai'] = this.optionsTrangThai.filter(x => x.show == true).map(x => {
			i = i + 1;
			return {
				id: i,
				name: x.name,
				value: x.value,
				checked: false,
				position: x.position
			}
		});
		this.filterGroupDataChecked['TrangThai'].sort(function(a,b){
			return a.position - b.position;
		})
		this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);

		this.changeDetect.detectChanges();
	}

	//#region Function check quyền
	isTrueButton(ROLENUMBER: string){
		if(this.LIST_ROLES_USER.findIndex(x => x == ROLENUMBER) > -1){
			return true;
		}
		return false;
	}
	//#endregion Function check quy
	
	//#region Load danh sach
	// Default
	loadKhoDeNghiXuatKhoList(highlight: boolean = false) {
		if(highlight == false) this.saveNewTTHV = [];
		this.selection.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadKhoDeNghiXuatKhos(queryParams);
	}

	// Load danh sách cho trường hợp xóa quay về trang trước đó nếu k còn dữ liệu ở trang đang load
	loadKhoDeNghiXuatKhoListPagePre(highlight: boolean = false) {
		if(highlight == false) this.saveNewTTHV = [];
		this.selection.clear();
		this.paginator.pageIndex = (this.paginator.pageIndex > 0)? this.paginator.pageIndex - 1 : 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadKhoDeNghiXuatKhos(queryParams);
	}
	
	// Load danh sách về trang đầu khi thêm hoặc tìm kiếm
	loadKhoDeNghiXuatKhoListInit(highlight: boolean = false) {
		if(highlight == false) this.saveNewTTHV = [];
		this.selection.clear();
		this.paginator.pageIndex = 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadKhoDeNghiXuatKhos(queryParams);
	}
	//#endregion Load danh sach

	//#region FILTRATION
	filterConfiguration(): any {
		const filter: any = {};
		filter.CoQuyen = this.CoQuyen;
		if (this.filterText) {
			filter.TrangThai = this.filterText['TrangThai'];
			filter.SoPhieu = this.filterText['SoPhieu'];
		}
		filter.FullSearch = this.searchFullText.nativeElement.value;
		return filter;
	}
	//#endregion  FILTRATION

	//#region Apply selected Column
	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}
	//#endregion Apply selected Column

	//#region Column
	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach(row => { if (!row.alwaysChecked) this.selectedColumns.deselect(row); });
		} else {
			this.availableColumns.forEach(row => this.selectedColumns.select(row));
		}
	}

    showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}

	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}

	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}

	dropListDropped(event: CdkDropList, column: string) {
		
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}

	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}

	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}

	//#endregion Column

	//#region Thêm mới, Chỉnh sửa
	addKhoDeNghiXuatKho() {
		const newKhoDeNghiXuatKho = new KhoDeNghiXuatKho();
		newKhoDeNghiXuatKho.clear(); // Set all defaults fields
		this.editKhoDeNghiXuatKho(newKhoDeNghiXuatKho);
	}

	copyKhoDeNghiXuatKho(item: KhoDeNghiXuatKho){
		let newKhoDeNghiXuatKho = new KhoDeNghiXuatKho();
		newKhoDeNghiXuatKho.clear(); 
		this.KhoDeNghiXuatKhoService.detail(item.IdDn).subscribe(res => {
			if (res.status === 1 && !(res.data.Tinhtrang === this.optionsTrangThai[4].value)) {
				newKhoDeNghiXuatKho = res.data;
				newKhoDeNghiXuatKho.IdDn = 0;
				newKhoDeNghiXuatKho.Sophieu = '';
				newKhoDeNghiXuatKho.TenNguoitao = '';
				newKhoDeNghiXuatKho.Tinhtrang = '';
				newKhoDeNghiXuatKho.DescTinhTrang = '';
				newKhoDeNghiXuatKho.Nguoitao = 0;
				newKhoDeNghiXuatKho.LoaiPhieu = item.LoaiPhieu;
				newKhoDeNghiXuatKho.ChiTiet.forEach(x =>{
					x.SLThucXuat = 0;
				});
				this.editKhoDeNghiXuatKho(newKhoDeNghiXuatKho, true);
			}else{
				this.layoutUtilsService.showErorr(res.error.message);
				if(res.status === -1 || ((res.data && res.status === 1)? this.isDeleteAndRemove(res.data.Tinhtrang): false)){
					this.saveNewTTHV.push(item.IdDn);
					this.loadKhoDeNghiXuatKhoList(true);
				}
			}
		});
	}

	editKhoDeNghiXuatKho(KhoDeNghiXuatKho: KhoDeNghiXuatKho, copyItem: boolean = false) {
		if(this.checkDashboardRoute())	return null;
		if(KhoDeNghiXuatKho.IdDn > 0 && !copyItem){
			// KhoDeNghiXuatKho.isQCKiemTra = false;
			this.KhoDeNghiXuatKhoService.detail(KhoDeNghiXuatKho.IdDn).subscribe(res => {
				if (res.status === 1 && !this.isDeleteAndRemove(res.data.Tinhtrang)) {
					const dialogRef = this.dialog.open(KhoDeNghiXuatKhoEditComponent, {
						data: {
							data: res.data,
							isCopy: false
						},
						maxHeight: '90vh',
						width: '90vw'
					});
	
					dialogRef.afterClosed().subscribe(res => {
						this.openDialog = false;
						this.loadKhoDeNghiXuatKhoList(true);
						if (res == undefined || res == null) {
							return;
						}
						else{
							if (!res.isChange) {
								return;
							}
							if(res.dataAdd.length != 0){
								this.saveNewTTHV = res.dataAdd;
							}
							this.loadKhoDeNghiXuatKhoList(true);
						}
					});
				}else{
					this.layoutUtilsService.showErorr(res.error.message);
					if(res.status === -1 || ((res.data && res.status === 1)? this.isDeleteAndRemove(res.data.Tinhtrang): false)){
						this.saveNewTTHV = [KhoDeNghiXuatKho.IdDn];
						this.loadKhoDeNghiXuatKhoList(true);
					}
				}
			});
		}
		else{
			const dialogRef = this.dialog.open(KhoDeNghiXuatKhoEditComponent, {
				data: {
					data: KhoDeNghiXuatKho,
					isCopy: true
				},
				maxHeight: '90vh',
				width: '90vw'
			});

			dialogRef.afterClosed().subscribe(res => {
				this.openDialog = false;
				this.loadKhoDeNghiXuatKhoListInit(true);
				if (res == undefined || res == null) {
					return;
				}
				else{
					if (!res.isChange) {
						this.loadKhoDeNghiXuatKhoList();
						return;
					}
					if(res.dataAdd.length != 0){
						this.saveNewTTHV = res.dataAdd;
					}
					this.paginator.pageIndex = 0;
					this.loadKhoDeNghiXuatKhoListInit(true);
				}
			});
		}
	}
	// #endregion Thêm mới, Chỉnh sửa
	
	//#region Xem chi tiết
	callDetail(item: any){
		if(this.checkDashboardRoute())	return null;
		this.KhoDeNghiXuatKhoService.detail(item.IdDn).subscribe(res => {
			if (res.status == 1) {
				const dialogRef = this.dialog.open(KhoDeNghiXuatKhoDetailComponent, {
					data: {
						data: res.data,
						canEdit: true
					},
					maxHeight: '90vh',
					width: '90vw'
				});

				dialogRef.afterClosed().subscribe(res => {
					this.loadKhoDeNghiXuatKhoList(true);
					if (res == undefined || res == null) {
						return;
					}
					else{
						this.saveNewTTHV = [];
						this.loadKhoDeNghiXuatKhoList(true);
					}
				});
			}else{
				this.layoutUtilsService.showErorr(res.error.message);
				if(res.status === -1){
					this.saveNewTTHV = [item.IdDn];
					this.loadKhoDeNghiXuatKhoList(true);
				}
			}
		});
	}
	//#endregion Xem chi tiết
	
	//#region Duyệt
	acceptItem(item, nguoiTao: boolean = false){
		if(this.checkDashboardRoute())	return null;
		this.openDialog = true;
		this.KhoDeNghiXuatKhoService.detail(item.IdDn).subscribe(res => {
			if (res.status == 1 && !this.isDeleteAndRemove(res.data.Tinhtrang)) {
				const dialogRef = this.dialog.open(KhoDeNghiXuatKhoDuyetComponent, {
					data: {
						data: res.data,
						nguoiTao : nguoiTao
					},
					maxHeight: '90vh',
					width: '90vw'
				});

				dialogRef.afterClosed().subscribe(res => {
					this.openDialog = false;
					if (res == undefined || res == null) {
						return;
					}
					else{
						if (!res.isChange) {
							return;
						}
						if(res.dataAdd.length != 0){
							this.saveNewTTHV = res.dataAdd;
						}
						this.loadKhoDeNghiXuatKhoList(true);
					}
				});
			}else{
				this.layoutUtilsService.showErorr(res.error.message? res.error.message  : "Trạng thái phiếu đã thay đổi, vui lòng tải lại");
				if(res.status === -1 || ((res.data && res.status === 1)? this.isDeleteAndRemove(res.data.Tinhtrang): false)){
					this.saveNewTTHV = [item.IdDn];
					this.loadKhoDeNghiXuatKhoList(true);
				}
			}
		});
	}
	//#endregion Duyệt

	//#region Xóa
	deleteItem(item){
		if(this.checkDashboardRoute())	return null;
		const _sophieu: string = item.Sophieu;
		const _deleteMessage = `Phiếu đề nghị xuất kho `+_sophieu+` đã được xóa`;
		const dialogRef = this.layoutUtilsService.POP01(_sophieu);

		dialogRef.afterClosed().subscribe(res => {
			this.forcusEvents();
			if (!res) {
				return;
			}
			this.KhoDeNghiXuatKhoService.delete(item.IdDn).subscribe(res => {
				if (res && res.status === 1) {
					this.layoutUtilsService.showInfo(_deleteMessage);
				}
				else {
                    this.layoutUtilsService.showErorr(res.error.message);
				}
				if(this.dataSource.entitySubject.value.length == 1){
					this.loadKhoDeNghiXuatKhoListPagePre();
				}
				else this.loadKhoDeNghiXuatKhoList();
			});
		});
	}
	//#endregion Xóa
	
	//#region Hủy
	closeItem(item){
		if(this.checkDashboardRoute())	return null;
		const _sophieu: string = item.Sophieu;
		const _deleteMessage = `Phiếu đề nghị xuất kho `+_sophieu+` đã được hủy`;
		const dialogRef = this.layoutUtilsService.POP04(_sophieu);

		dialogRef.afterClosed().subscribe(res => {
			this.forcusEvents();
			if (!res) {
				return;
			}
			this.KhoDeNghiXuatKhoService.remove(item.IdDn).subscribe(res => {
				if (res && res.status === 1) {
					this.layoutUtilsService.showInfo(_deleteMessage);
					this.saveNewTTHV=[item.IdDn];
					this.loadKhoDeNghiXuatKhoList(true);
				}
				else {
                    this.layoutUtilsService.showErorr(res.error.message);
                }
				
			});
		});
	}
	//#endregion Hủy

	//#region Chỉnh sửa các trường trên lưới
	resetValueUpdate(columnName:string, item:any){
		if(columnName == 'Sophieu')
			this.KhoDeNghiXuatKhoResult[this.KhoDeNghiXuatKhoResult.indexOf(item)].Sophieu = this.tmpKhoDeNghiXuatKhoResult[this.KhoDeNghiXuatKhoResult.indexOf(item)].Sophieu;
	}

	changeValueOfColumn(columnName:string, item:any, event: any, afterUpdate: boolean){
		if(columnName == 'Sophieu'){
			if(afterUpdate){
				this.tmpKhoDeNghiXuatKhoResult[this.KhoDeNghiXuatKhoResult.indexOf(item)].Sophieu = item.Sophieu
			}
			else{
				this.KhoDeNghiXuatKhoResult[this.KhoDeNghiXuatKhoResult.indexOf(item)].Sophieu = event.target.value.trim();
				//this.updateKhoDeNghiXuatKho('Sophieu',item);
			}
		}
	}

	isChangeValue(columnName:string, item:any){
		if(columnName == 'Sophieu' && this.KhoDeNghiXuatKhoResult[this.KhoDeNghiXuatKhoResult.indexOf(item)].Sophieu != this.tmpKhoDeNghiXuatKhoResult[this.KhoDeNghiXuatKhoResult.indexOf(item)].Sophieu)
			return true;
		return false;
	}

	ValidateChangeNumberEvent(columnName:string, item:any, event: any) {
		var count = 0;
		for(let i = 0; i < event.target.value.length; i++){
			if(event.target.value[i] == '.'){
				count += 1;
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	//#endregion Chỉnh sửa các trường trên lưới

	//#region Format
	formatNumber(item: string){
		if(item == '' || item == null || item == undefined)	return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
	}

	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}

	f_currency_V2(value: string): any {
		if(value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}

	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	//#endregion Format

	//#region Lấy danh sách tên trạng thái
	getNameOfTrangThai(TrangThai: number){
		if(TrangThai == 0)
			return 'Chưa duyệt';
		else if(TrangThai == 1)
			return 'Đã duyệt';
		else if(TrangThai == 2)
			return 'Bị trả lại';
		else if(TrangThai == 4)
			return 'Chờ kiểm tra';
		else if(TrangThai == 5)
			return 'Đang kiểm tra';
		else if(TrangThai == 6)
			return 'Đã kiểm tra';
		return '';
	}
	//#endregion Lấy danh sách tên trạng thái
	
	//#region Highlight dữ liệu
	highlightNewestRecord(item : any){
		var index = this.KhoDeNghiXuatKhoResult.findIndex(x => x.IdDn == item.IdDn && x.Sophieu == item.Sophieu);
		let saveNewIndex = this.saveNewTTHV.indexOf(this.KhoDeNghiXuatKhoResult[index].IdDn)
		if (saveNewIndex > -1) {
			setTimeout(() => {
				this.saveNewTTHV.splice(saveNewIndex, 1)
			}, 3000);
			return true;
		}
		return false;
	}
	//#endregion Highlight dữ liệu

	//#region Focus
	forcusEvents(){
		this.openDialog = false;
		this.changeDetect.detectChanges();
	}
	//#endregion Focus, Filter

	//#region Lấy css theo trạng thái
	getItemCssClassByStatus(status: any): string {
		switch (status) {
			case this.optionsTrangThai[0].value:
				return this.CONFIG.COLOR_STATE._DangSoanThaoCase;
			case this.optionsTrangThai[1].value:
				return this.CONFIG.COLOR_STATE._ChoXacNhanXuLyCase;
			case this.optionsTrangThai[2].value:
				return this.CONFIG.COLOR_STATE._HoanTatCase;
			case this.optionsTrangThai[3].value:
				return this.CONFIG.COLOR_STATE._HuyCase;
			default:
				return this.CONFIG.COLOR_STATE._DangSoanThaoCase;;
		}
	}
	//#endregion Lấy css theo trạng thái

	//#region Filter function
	SelectAll(event, col) {
		if (event.checked) {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = true;
			});
		}
		else {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = false;
			});
		}
	}
	isColumnSelectAll(col) {
		if (this.filterGroupDataCheckedFake[col]) {
			let lst_checked = this.filterGroupDataCheckedFake[col].filter(opt => opt.checked).map(opt => opt.value);
			if (lst_checked) {
				if (lst_checked.length != this.filterGroupDataCheckedFake[col].length) {
					return false;
				}
				else {
					return true;
				}
			}
			else {
				return false;
			}
		}
		return false;
	}
	LoadDataDropFilter(col) {
		this.tmpfilterText = Object.assign({}, this.filterText);
		if (this.filterGroupDataChecked && this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col] && this.filterGroupDataChecked[col]) {
			this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
		}
	}
	// isSelect : true list chon | false là nhap text
	disableDoneButton(col , isSelect = true) {
		let countChecked = 0;
		
		if(isSelect){
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {
					if (elementFake.checked) {
						countChecked++;
					}
				}
			}
			if (countChecked > 0) {
				this.disableButtonFilter[col] = false;
			}
			else {
				this.disableButtonFilter[col] = true;
			}
		}else{
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				if (this.filterGroupDataCheckedFake[col].length > 0) {
					this.disableButtonFilter[col] = false;
				}
				else {
					this.disableButtonFilter[col] = true;
				}
			}
		}
	}
	showClearAllButton() {
		
		let _count = 0;
		for (var key in this.filterGroupArray) {
			if (this.filterGroupArray.hasOwnProperty(key)) {
				if (this.filterGroupArray[key]) {
					let _arrflt = this.filterGroupArray[key].filter(opt => opt.checked);
					if(_arrflt.length == 0 && this.filterGroupArray[key].length == 1){
						_arrflt = this.filterGroupArray[key].filter(opt => opt);
					}
					_count += _arrflt ? _arrflt.length : 0;
				}
			}
		}
		let _text = "";
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				_text += this.filterText[key];
			}
		}
		if (_count > 0 || _text) {
			this.isClearAll = true;
		}
		else {
			this.isClearAll = false;
		}
	}
	filterHead(col, isSelect = true) {
		if(isSelect){
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {
					let index = this.filterGroupDataChecked[col].findIndex(x => x.id == elementFake.id);
					if (index > -1)
						this.filterGroupDataChecked[col][index].checked = elementFake.checked;
				}
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked).map(op => op.value);

				this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
				this.tmpfilterText[col] = '';
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				this.filterConfiguration();
			}
			this.loadKhoDeNghiXuatKhoListInit();
			this.isClearAll = this.checkFilterHasValue(this.filterGroupDataChecked, 'ALL');
		}else{
			if (this.filterGroupDataCheckedFake ) {
				if(!this.filterGroupDataCheckedFake[col]){
					this.remove('', col, false);
				}else{
					this.filterGroupData[col] = [];
					this.filterGroupArray[col] = [this.filterGroupDataCheckedFake[col]];
					this.filterGroupData[col] = [this.filterGroupDataCheckedFake[col]];
					if(this.filterGroupData[col]) 
						this.tmpfilterText[col] = '';
				}
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				this.filterConfiguration();
			}
			this.loadKhoDeNghiXuatKhoListInit();
			this.isClearAll = this.checkFilterHasValue(this.filterGroupDataCheckedFake, col, false);
			this.filterGroupDataCheckedFake[col] = '';
		}
	}
	remove(item, col, isSelect = true) {
		if(isSelect){
			let _index = this.filterGroupDataChecked[col].findIndex(x => x.value == item.value);
			if (_index > -1) {
				this.filterGroupDataChecked[col][_index].checked = false;
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked).map(op => op.value);

				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.loadKhoDeNghiXuatKhoListInit();
			}
		}else{
			let _index = this.filterGroupDataCheckedFake[col].length;
			if (_index > -1) {
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupData[col] = [];

				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.filterGroupDataCheckedFake[col] = '';
				this.loadKhoDeNghiXuatKhoListInit();
			}
		}
		
	}
	Clear() {
		this.filterGroupData = [];
		this.filterGroupArray = [];
		for (var key in this.filterGroupDataChecked) {
			if (this.filterGroupDataChecked.hasOwnProperty(key)) {
				if (this.filterGroupDataChecked[key]) {
					this.filterGroupDataChecked[key].forEach(element => {
						element.checked = false;
					});
					this.disableButtonFilter[key] = true;
				}
			}
		}
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				this.filterText[key] = "";
			}
		}
		this.isClearAll = false;
		this.loadKhoDeNghiXuatKhoListInit();
		this.forcusEvents();
	}
	checkFilterHasValue(data, col, isSelect = true) {
		
		let _count = 0;
		if(isSelect){
			if (col == 'ALL' && data) {//check all column
				for (var key in data) {
					if (data.hasOwnProperty(key)) {
						if (data[key]) {
							let _arrflt = data[key].filter(opt => opt.checked);
							_count += _arrflt ? _arrflt.length : 0;
						}
					}
				}
				let _text = "";
				for (var key in this.filterText) {
					if (this.filterText.hasOwnProperty(key)) {
						_text += this.filterText[key];
					}
				}
				if (_count > 0 || _text) {
					return true;
				}
			}
			else {//check in 1 column
				if (data && data[col]) {
					let _arrflt = data[col].filter(opt => opt.checked);
					_count += _arrflt ? _arrflt.length : 0;
				}
				if (_count > 0) {
					return true;
				}
			}
		}else{
			if(data && data[col] && data[col].length > 0){
				if (data[col].length > 0) {
					return true;
				}
			}
		}
		return false;
	}
	filterGroupWithTextFilter(columnName: string) {
		let search = this.tmpfilterText[columnName]

		if (!search) {
			this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].map(x => Object.assign({}, x));
			return;
		} else {
			search = search.toLowerCase();
		}

		this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].filter(
			ts => ts.name.toLowerCase().indexOf(search) > -1)

		this.changeDetect.detectChanges();
	}
	//#endregion Filter function

	//#region Check người tạo với người đang login
	checkUserCreate(item: any){
		return +item.Nguoitao == this.IdUser;
	}
	//#endregion Check người tạo với người đang login

	//#region Check router
	checkDashboardRoute(){
		if(this.router.url === '/')
			return true;
		return false;
	}
	//#endregion Check router
	isDeleteAndRemove(status: string){
		return ((status === this.optionsTrangThai[3].value) || (status === this.optionsTrangThai[4].value));
	}

	isCreate(item:any){
		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		let element = this.tmpKhoDeNghiXuatKhoResult.find(x => x.IdDn == item.IdDn);
		if(element != null && (element.Nguoitao == +idUser)){
			return true;
		}
		return false;
	}

	getNumOfState(item : KhoDeNghiXuatKho){
		var choDuyet = (item.ChoDuyet == 0)? "" : (item.ChoDuyet + " chờ duyệt");
		var choDong = (item.ChoDong == 0)? "" : (item.ChoDong + " chờ đóng");
		return choDuyet + (choDuyet && choDong ? ", " : "" )+ choDong;
	}
}

